import { withAsyncBoundary } from '@toss/async-boundary';
import { PlanPaymentPendingDeposit } from '../../../../components/service/plan-payment';
const _OnetimePaymentsPendingDepositPageView = () => {
  return <PlanPaymentPendingDeposit data-sentry-element="PlanPaymentPendingDeposit" data-sentry-component="_OnetimePaymentsPendingDepositPageView" data-sentry-source-file="OnetimePaymentsPendingDepositPageView.tsx" />;
};
export const OnetimePaymentsPendingDepositPageView = withAsyncBoundary(_OnetimePaymentsPendingDepositPageView, {
  pendingFallback: null,
  rejectedFallback: () => null
});